import service from '@/store/services/skills-service';

const state = {
    usersList: {},
    adminSkillsData: {},
    userSkillsData: {},
    userSkills: {},
};

const mutations = {
    SET_USERS_LIST: (state, usersList) => {
        state.usersList = usersList;
    },
    SET_ADMIN_SKILLS_DATA: (state, adminSkillsData) => {
        state.adminSkillsData = adminSkillsData;
    },
    SET_USER_SKILLS_DATA: (state, userSkillsData) => {
        state.userSkillsData = userSkillsData;
    },

    SET_USER_SKILLS: (state, userSkills) => {
        state.userSkills = userSkills;
    },

};

const actions = {
    usersList({dispatch, commit}, params) {
        return service.showUsersList(params).then(({usersList}) => {
            commit('SET_USERS_LIST', usersList);
        });
    },
    adminSkillsData({dispatch, commit}, params) {
        return service.adminSkillsData(params).then(({adminSkillsData}) => {
            commit('SET_ADMIN_SKILLS_DATA', adminSkillsData);
        });
    },
    userSkillsData({dispatch, commit}, params) {
        return service.userSkillsData(params).then(({userSkillsData}) => {
            commit('SET_USER_SKILLS_DATA', userSkillsData);
        });
    },
    userSkills({dispatch, commit}, params) {
        return service.userSkills(params).then(({userSkills}) => {
            commit('SET_USER_SKILLS', userSkills);
        });
    },
};

const getters = {
    usersList: state => state.usersList,
    adminSkillsData: state => state.adminSkillsData,
    userSkillsData: state => state.userSkillsData,
    userSkills: state => state.userSkills,
};

const skills = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default skills;